/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSpaceRouteImport } from './routes/_auth/space'
import { Route as AuthRedirectRouteImport } from './routes/_auth/redirect'
import { Route as AuthWorkLayoutWorkspaceSlugRouteRouteImport } from './routes/_auth/_work-layout.$workspaceSlug/route'
import { Route as AuthWorkLayoutWorkspaceSlugIndexRouteImport } from './routes/_auth/_work-layout.$workspaceSlug/index'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/route'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIndexRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/index'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/workspace'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsProfileRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/profile'
import { Route as AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRouteImport } from './routes/_auth/_work-layout.$workspaceSlug/shortcuts/$shortcutSlug/index'
import { Route as AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRouteImport } from './routes/_auth/_work-layout.$workspaceSlug/agents/$agentSlug/index'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/index'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/whatsapp'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/outlook'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/gmap'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/gmail'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/fmcsa'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/fedex'
import { Route as AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRouteImport } from './routes/_auth/_settings-layout.$workspaceSlug.settings/integrations/excel'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSpaceRoute = AuthSpaceRouteImport.update({
  id: '/space',
  path: '/space',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRedirectRoute = AuthRedirectRouteImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkLayoutWorkspaceSlugRouteRoute =
  AuthWorkLayoutWorkspaceSlugRouteRouteImport.update({
    id: '/_work-layout/$workspaceSlug',
    path: '/$workspaceSlug',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthWorkLayoutWorkspaceSlugIndexRoute =
  AuthWorkLayoutWorkspaceSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthWorkLayoutWorkspaceSlugRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteImport.update({
    id: '/_settings-layout/$workspaceSlug/settings',
    path: '/$workspaceSlug/settings',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute =
  AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRouteImport.update({
    id: '/shortcuts/$shortcutSlug/',
    path: '/shortcuts/$shortcutSlug/',
    getParentRoute: () => AuthWorkLayoutWorkspaceSlugRouteRoute,
  } as any)
const AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute =
  AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRouteImport.update({
    id: '/agents/$agentSlug/',
    path: '/agents/$agentSlug/',
    getParentRoute: () => AuthWorkLayoutWorkspaceSlugRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRouteImport.update(
    {
      id: '/integrations/whatsapp',
      path: '/integrations/whatsapp',
      getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
    } as any,
  )
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRouteImport.update({
    id: '/integrations/outlook',
    path: '/integrations/outlook',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRouteImport.update({
    id: '/integrations/gmap',
    path: '/integrations/gmap',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRouteImport.update({
    id: '/integrations/gmail',
    path: '/integrations/gmail',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRouteImport.update({
    id: '/integrations/fmcsa',
    path: '/integrations/fmcsa',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRouteImport.update({
    id: '/integrations/fedex',
    path: '/integrations/fedex',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)
const AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute =
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRouteImport.update({
    id: '/integrations/excel',
    path: '/integrations/excel',
    getParentRoute: () => AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/redirect': typeof AuthRedirectRoute
  '/space': typeof AuthSpaceRoute
  '/$workspaceSlug': typeof AuthWorkLayoutWorkspaceSlugRouteRouteWithChildren
  '/$workspaceSlug/settings': typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteWithChildren
  '/$workspaceSlug/': typeof AuthWorkLayoutWorkspaceSlugIndexRoute
  '/$workspaceSlug/settings/profile': typeof AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute
  '/$workspaceSlug/settings/workspace': typeof AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute
  '/$workspaceSlug/settings/': typeof AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute
  '/$workspaceSlug/settings/integrations/excel': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute
  '/$workspaceSlug/settings/integrations/fedex': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute
  '/$workspaceSlug/settings/integrations/fmcsa': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute
  '/$workspaceSlug/settings/integrations/gmail': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute
  '/$workspaceSlug/settings/integrations/gmap': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute
  '/$workspaceSlug/settings/integrations/outlook': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute
  '/$workspaceSlug/settings/integrations/whatsapp': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute
  '/$workspaceSlug/settings/integrations': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute
  '/$workspaceSlug/agents/$agentSlug': typeof AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute
  '/$workspaceSlug/shortcuts/$shortcutSlug': typeof AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/redirect': typeof AuthRedirectRoute
  '/space': typeof AuthSpaceRoute
  '/$workspaceSlug': typeof AuthWorkLayoutWorkspaceSlugIndexRoute
  '/$workspaceSlug/settings/profile': typeof AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute
  '/$workspaceSlug/settings/workspace': typeof AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute
  '/$workspaceSlug/settings': typeof AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute
  '/$workspaceSlug/settings/integrations/excel': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute
  '/$workspaceSlug/settings/integrations/fedex': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute
  '/$workspaceSlug/settings/integrations/fmcsa': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute
  '/$workspaceSlug/settings/integrations/gmail': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute
  '/$workspaceSlug/settings/integrations/gmap': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute
  '/$workspaceSlug/settings/integrations/outlook': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute
  '/$workspaceSlug/settings/integrations/whatsapp': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute
  '/$workspaceSlug/settings/integrations': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute
  '/$workspaceSlug/agents/$agentSlug': typeof AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute
  '/$workspaceSlug/shortcuts/$shortcutSlug': typeof AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/redirect': typeof AuthRedirectRoute
  '/_auth/space': typeof AuthSpaceRoute
  '/_auth/_work-layout/$workspaceSlug': typeof AuthWorkLayoutWorkspaceSlugRouteRouteWithChildren
  '/_auth/_settings-layout/$workspaceSlug/settings': typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteWithChildren
  '/_auth/_work-layout/$workspaceSlug/': typeof AuthWorkLayoutWorkspaceSlugIndexRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/profile': typeof AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/workspace': typeof AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/': typeof AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/excel': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fedex': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fmcsa': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmail': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmap': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/outlook': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/whatsapp': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute
  '/_auth/_settings-layout/$workspaceSlug/settings/integrations/': typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute
  '/_auth/_work-layout/$workspaceSlug/agents/$agentSlug/': typeof AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute
  '/_auth/_work-layout/$workspaceSlug/shortcuts/$shortcutSlug/': typeof AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/redirect'
    | '/space'
    | '/$workspaceSlug'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/'
    | '/$workspaceSlug/settings/profile'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/settings/'
    | '/$workspaceSlug/settings/integrations/excel'
    | '/$workspaceSlug/settings/integrations/fedex'
    | '/$workspaceSlug/settings/integrations/fmcsa'
    | '/$workspaceSlug/settings/integrations/gmail'
    | '/$workspaceSlug/settings/integrations/gmap'
    | '/$workspaceSlug/settings/integrations/outlook'
    | '/$workspaceSlug/settings/integrations/whatsapp'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/agents/$agentSlug'
    | '/$workspaceSlug/shortcuts/$shortcutSlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/redirect'
    | '/space'
    | '/$workspaceSlug'
    | '/$workspaceSlug/settings/profile'
    | '/$workspaceSlug/settings/workspace'
    | '/$workspaceSlug/settings'
    | '/$workspaceSlug/settings/integrations/excel'
    | '/$workspaceSlug/settings/integrations/fedex'
    | '/$workspaceSlug/settings/integrations/fmcsa'
    | '/$workspaceSlug/settings/integrations/gmail'
    | '/$workspaceSlug/settings/integrations/gmap'
    | '/$workspaceSlug/settings/integrations/outlook'
    | '/$workspaceSlug/settings/integrations/whatsapp'
    | '/$workspaceSlug/settings/integrations'
    | '/$workspaceSlug/agents/$agentSlug'
    | '/$workspaceSlug/shortcuts/$shortcutSlug'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_auth/redirect'
    | '/_auth/space'
    | '/_auth/_work-layout/$workspaceSlug'
    | '/_auth/_settings-layout/$workspaceSlug/settings'
    | '/_auth/_work-layout/$workspaceSlug/'
    | '/_auth/_settings-layout/$workspaceSlug/settings/profile'
    | '/_auth/_settings-layout/$workspaceSlug/settings/workspace'
    | '/_auth/_settings-layout/$workspaceSlug/settings/'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/excel'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fedex'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fmcsa'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmail'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmap'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/outlook'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/whatsapp'
    | '/_auth/_settings-layout/$workspaceSlug/settings/integrations/'
    | '/_auth/_work-layout/$workspaceSlug/agents/$agentSlug/'
    | '/_auth/_work-layout/$workspaceSlug/shortcuts/$shortcutSlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/space': {
      id: '/_auth/space'
      path: '/space'
      fullPath: '/space'
      preLoaderRoute: typeof AuthSpaceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/redirect': {
      id: '/_auth/redirect'
      path: '/redirect'
      fullPath: '/redirect'
      preLoaderRoute: typeof AuthRedirectRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_work-layout/$workspaceSlug': {
      id: '/_auth/_work-layout/$workspaceSlug'
      path: '/$workspaceSlug'
      fullPath: '/$workspaceSlug'
      preLoaderRoute: typeof AuthWorkLayoutWorkspaceSlugRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_work-layout/$workspaceSlug/': {
      id: '/_auth/_work-layout/$workspaceSlug/'
      path: '/'
      fullPath: '/$workspaceSlug/'
      preLoaderRoute: typeof AuthWorkLayoutWorkspaceSlugIndexRouteImport
      parentRoute: typeof AuthWorkLayoutWorkspaceSlugRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings'
      path: '/$workspaceSlug/settings'
      fullPath: '/$workspaceSlug/settings'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/'
      path: '/'
      fullPath: '/$workspaceSlug/settings/'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIndexRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/workspace': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/workspace'
      path: '/workspace'
      fullPath: '/$workspaceSlug/settings/workspace'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/profile': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/profile'
      path: '/profile'
      fullPath: '/$workspaceSlug/settings/profile'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsProfileRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_work-layout/$workspaceSlug/shortcuts/$shortcutSlug/': {
      id: '/_auth/_work-layout/$workspaceSlug/shortcuts/$shortcutSlug/'
      path: '/shortcuts/$shortcutSlug'
      fullPath: '/$workspaceSlug/shortcuts/$shortcutSlug'
      preLoaderRoute: typeof AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRouteImport
      parentRoute: typeof AuthWorkLayoutWorkspaceSlugRouteRoute
    }
    '/_auth/_work-layout/$workspaceSlug/agents/$agentSlug/': {
      id: '/_auth/_work-layout/$workspaceSlug/agents/$agentSlug/'
      path: '/agents/$agentSlug'
      fullPath: '/$workspaceSlug/agents/$agentSlug'
      preLoaderRoute: typeof AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRouteImport
      parentRoute: typeof AuthWorkLayoutWorkspaceSlugRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/'
      path: '/integrations'
      fullPath: '/$workspaceSlug/settings/integrations'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/whatsapp': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/whatsapp'
      path: '/integrations/whatsapp'
      fullPath: '/$workspaceSlug/settings/integrations/whatsapp'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/outlook': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/outlook'
      path: '/integrations/outlook'
      fullPath: '/$workspaceSlug/settings/integrations/outlook'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmap': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmap'
      path: '/integrations/gmap'
      fullPath: '/$workspaceSlug/settings/integrations/gmap'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmail': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/gmail'
      path: '/integrations/gmail'
      fullPath: '/$workspaceSlug/settings/integrations/gmail'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fmcsa': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fmcsa'
      path: '/integrations/fmcsa'
      fullPath: '/$workspaceSlug/settings/integrations/fmcsa'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fedex': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/fedex'
      path: '/integrations/fedex'
      fullPath: '/$workspaceSlug/settings/integrations/fedex'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
    '/_auth/_settings-layout/$workspaceSlug/settings/integrations/excel': {
      id: '/_auth/_settings-layout/$workspaceSlug/settings/integrations/excel'
      path: '/integrations/excel'
      fullPath: '/$workspaceSlug/settings/integrations/excel'
      preLoaderRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRouteImport
      parentRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute
    }
  }
}

interface AuthWorkLayoutWorkspaceSlugRouteRouteChildren {
  AuthWorkLayoutWorkspaceSlugIndexRoute: typeof AuthWorkLayoutWorkspaceSlugIndexRoute
  AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute: typeof AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute
  AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute: typeof AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute
}

const AuthWorkLayoutWorkspaceSlugRouteRouteChildren: AuthWorkLayoutWorkspaceSlugRouteRouteChildren =
  {
    AuthWorkLayoutWorkspaceSlugIndexRoute:
      AuthWorkLayoutWorkspaceSlugIndexRoute,
    AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute:
      AuthWorkLayoutWorkspaceSlugAgentsAgentSlugIndexRoute,
    AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute:
      AuthWorkLayoutWorkspaceSlugShortcutsShortcutSlugIndexRoute,
  }

const AuthWorkLayoutWorkspaceSlugRouteRouteWithChildren =
  AuthWorkLayoutWorkspaceSlugRouteRoute._addFileChildren(
    AuthWorkLayoutWorkspaceSlugRouteRouteChildren,
  )

interface AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteChildren {
  AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute
  AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute
  AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute
}

const AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteChildren: AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteChildren =
  {
    AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsProfileRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsWorkspaceRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIndexRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsExcelRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFedexRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsFmcsaRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmailRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsGmapRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsOutlookRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsWhatsappRoute,
    AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute:
      AuthSettingsLayoutWorkspaceSlugSettingsIntegrationsIndexRoute,
  }

const AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteWithChildren =
  AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute._addFileChildren(
    AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteChildren,
  )

interface AuthRouteChildren {
  AuthRedirectRoute: typeof AuthRedirectRoute
  AuthSpaceRoute: typeof AuthSpaceRoute
  AuthWorkLayoutWorkspaceSlugRouteRoute: typeof AuthWorkLayoutWorkspaceSlugRouteRouteWithChildren
  AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute: typeof AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthRedirectRoute: AuthRedirectRoute,
  AuthSpaceRoute: AuthSpaceRoute,
  AuthWorkLayoutWorkspaceSlugRouteRoute:
    AuthWorkLayoutWorkspaceSlugRouteRouteWithChildren,
  AuthSettingsLayoutWorkspaceSlugSettingsRouteRoute:
    AuthSettingsLayoutWorkspaceSlugSettingsRouteRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
